<template>
  <div class="chinaEuropeTrain">
    <Header :typeHeader="'defaultHeader'">
      <!-- banner -->
      <img slot="headerImage" :src="imgList.bannerImg" alt="" />
      <!-- 标题 -->
      <div slot="headerTitle">{{$store.state.navShow == true ?'MG物流云系统':'Logistics cloud platform'}}</div>
      <div
        style="
          font-size: 1.125rem;
          color: #ffffff;
          font-weight: 100;
          margin-top: 0.6rem;
        "
        slot="headerTitle"
      >
        {{$store.state.navShow == true ?'专业国际物流定位系统':'Digital management of international logistics innovation'}}
      </div>
    </Header>

    <div class="TopTitle" data-aos="fade-right">
      <!-- data-aos="fade-up-left" -->
      <div class="">
        <!-- {{this.$route.name}} -->
       {{$store.state.navShow == true ? $route.name : $route.meta.EnName}}
      </div>
    </div>
    <!-- fade-down -->
    <div class="ContentText" data-aos="slide-right">
      <!-- <p>
        基于中欧班列运营操作业务而建立的动态的、连续的、集中的智慧型物流管理标准化协同作业平台。
        系统涵盖业务、财务数据、单证操作各信息环节，通过业务数据进行定制化设计，智能化精准算法，全链条监管操作；平台以动态变化的视角分析和监管企业日常运作，构建以数据价值为中心的流动监管体系，解决企业数据集中作业以及数据管理需求，全面提升企业大数据管理能力。
      </p> -->
       <p style="margin-bottom: 0">
        {{$store.state.navShow == true ? '基于中欧班列运营操作业务而建立的动态的、连续的、集中的智慧型物流管理标准化协同作业平台。':'A dynamic, continuous and centralized intelligent logistics management standardized collaborative operation platform based on the China-Europe Railway Express operation business.'}}
      </p>
      <p>
        {{$store.state.navShow == true ? '系统涵盖业务、财务数据、单证操作各信息环节，通过业务数据进行定制化设计，智能化精准算法，全链条监管操作；平台以动态变化的视角分析和监管企业日常运作，构建以数据价值为中心的流动监管体系，解决企业数据集中作业以及数据管理需求，全面提升企业大数据管理能力。': "The system covers all information links of business, financial data and document operation and carries out customized design, intelligent and accurate algorithm through business data; The platform analyzes and supervises the daily operation of enterprises from the perspective of dynamic changes, constructs a mobile supervision system centered on data value to solves the needs of enterprise data centralized operation and data management and to comprehensively improves the ability of enterprise big data management."}}
      </p>
    </div>

    <div class="ContactCons">
      <img
        class="ContactConsImage"
        src="../../../assets/freightTracking/tt.jpg"
        alt=""
        v-if="$store.state.navShow == true"/>
        <img
        class="ContactConsImage"
        src="../../../assets/freightTracking/ttE.jpg"
        alt=""
        v-else
      />
      <div class="tableTitleTitle3">{{$store.state.navShow == true ? '系统特点' : 'System Features'}}</div>

      <div class="Docking">
        <div
          class="DockingList"
          v-for="(item, index) in DockingList"
          :key="index"
          data-aos="fade-right"
        >
          <img
            class="DockingListImg"
            :src="item.icon"
            :style="'width:' + item.iconW + 'px;'"
          />
          <div class="DockingListText">
            {{ $store.state.navShow == true ? item.title: item.titleE}}
          </div>
        </div>
      </div>

      <!-- <div class="freightTrackingTitle">
				<img class="freightTrackingImg" src="../../../assets/freightTracking/search.png">
				<div class="freightTrackingText">
					货运追踪查询
				</div>
			</div>
			<div class="freightTrackingCon">
				<div class="queryKuang">
					<div class="inputTextarea">
						<el-input class="que/ryKuangInput" v-model="textarea" placeholder="请填入箱号"></el-input>
					</div>
					立即查询按钮
					<div class="nowQuery" @click="nowQueryClick">
						<img src="../../../assets/freightTracking/query.png" alt="">
						<div id="">
							立即查询
						</div>
					</div>
				</div>

				<div class="tableTitleTitle3">
					货运追踪查询
				</div>

				<div class="freightTrackingCountry">
					<div class="freightTrackingCountryList" v-for="(item,index) in CountryList" :key="index">
						<div class="freightTrackingCountryListCon">
							<img class="freightTrackingCountryListConImg" :src="item.img01">
							<div class="freightTrackingCountryListConText">
								{{ item.name01 }}
							</div>
						</div>
						<div class="freightTrackingCountryListCon">
							<img class="freightTrackingCountryListConImg" :src="item.img02">
							<div class="freightTrackingCountryListConText">
								{{ item.name02 }}
							</div>
						</div>
					</div>
				</div>
			</div> -->
    </div>
    <!-- 
		<div class="bottonBackground" data-aos="fade-up">
			<img src="../../../assets/freightTracking/bottonbackground.png">
		</div> -->

    <div class="buttonImgFT">
      <!-- <img :src="imgList.bottonImg"> -->
      <img src="../../../assets/freightTracking/ffadfs.png" />
    </div>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
export default {
  components: {
    Header,
  },
  data() {
    return {
      imgList: {
        bannerImg: require("@/assets/freightTracking/banner.jpg"),
        // backgroundImg: require('@/assets/chinaAndRussia/backgroundImg.png'),
        // aircraft: require('@/assets/chinaAndRussia/aircraft.png'),
        bottonImg: require("@/assets/chinaAndRussia/currency.png"),
      },
      // 多行文本 内容左边的上部分
      textarea: "",
      DockingList: [
        {
          icon: require("@/assets/freightTracking/t1.png"),
          title: "高效匹配板块断点",
          titleE: "Efficiently match plate breakpoints",
          iconW: "52",
        },
        {
          icon: require("@/assets/freightTracking/t2.png"),
          title: "智能算法避免人工失误",
          titleE: "Smart algorithms avoid human errors",
          iconW: "57",
        },
        {
          icon: require("@/assets/freightTracking/t3.png"),
          title: "强大技术团队系统功能全面",
          titleE: "Strong technical team with comprehensive system functions",
          iconW: "56",
        },
        {
          icon: require("@/assets/freightTracking/t4.png"),
          title: "数据安全保密保护客户隐私",
          titleE: "Data security and confidentiality to protect customer privacy",
          iconW: "54",
        },
      ],
      CountryList: [
        {
          name01: "俄罗斯",
          img01: require("@/assets/freightTracking/Country1-1.png"),

          name02: "哈萨克斯坦",
          img02: require("@/assets/freightTracking/Country1-2.png"),
        },
        {
          name01: "蒙古国",
          img01: require("@/assets/freightTracking/Country2-1.png"),

          name02: "吉尔吉斯斯坦",
          img02: require("@/assets/freightTracking/Country2-2.png"),
        },
        {
          name01: "乌兹别克斯坦",
          img01: require("@/assets/freightTracking/Country3-1.png"),

          name02: "白俄罗斯",
          img02: require("@/assets/freightTracking/Country3-2.png"),
        },
        {
          name01: "波 兰",
          img01: require("@/assets/freightTracking/Country4-1.png"),

          name02: "德 国",
          img02: require("@/assets/freightTracking/Country4-2.png"),
        },
      ],
    };
  },
  methods: {
    /**
     * 立即查询按钮
     * 罗锦炜
     * 2021-12-06
     */
    nowQueryClick() {
      // 判断输入的内容是否为空
      if (this.textarea === "") {
        // 为空情况
        this.$message({
          showClose: true,
          message: "请输入查询内容",
          type: "warning",
        });
      } else {
        // 不为空的情况
        // window.location.href = 'http://demo.arkics.com/portal/orderSop/4360?jobNo=' + this.textarea;
        window.open(
          "http://demo.arkics.com/portal/orderSop/4360?jobNo=" + this.textarea,
          "_blank"
        ); // 打开新的窗口
      }
      // console.log('立即查询按钮',this.textarea)
    },
  },
};
</script>
<!-- 头部 -->
<style lang="less">
.TopTitle {
  width: 92%;
  height: 4.95rem;
  position: relative;
  margin: 0 4%;
  top: -3.2rem;
  border-bottom: 1px solid rgba(204, 204, 204, 0.5);

  & > div {
    position: absolute;
    top: 1.25rem;
    font-size: 1rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    padding: 1.2rem 3.375rem 1.2rem 0.75rem;
    background: #2e67b1
      linear-gradient(270deg, rgba(3, 0, 0, 0.15), hsla(0, 0%, 100%, 0.15));
  }
}

.ContentText {
  width: 92%;
  margin: 0 4%;
  // background-color: #000066;
  margin-top: -1.575rem;
  text-align: left;

  & > p {
    font-size: 0.875rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-indent: 2em;
    margin-bottom: 1.25rem;
    text-align: justify;
  }
}
</style>

<style lang="less">
.ContactCons {
  width: 92%;
  margin: 0 4%;
  //   box-shadow: 0px 0px 20px 0px rgba(41, 92, 169, 0.1);
  .ContactConsImage {
    width: 100%;
    height: 52rem;
  }
  .Docking {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: -3rem;
    .DockingList {
      width: 48.5%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      box-shadow: 0px 0px 20px 0px rgba(41, 92, 169, 0.1);
      margin-bottom: 0.625rem;

      .DockingListImg {
        // width: 2rem;
        height: 3.5rem;
        margin-top: 0.7625rem;
      }

      .DockingListText {
        width: 85%;
        font-size: 0.6875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        margin-bottom: 0.71875rem;
      }
    }
  }

  .freightTrackingTitle {
    width: 100%;
    box-shadow: 0px 0px 20px 0px rgba(45, 99, 171, 0.1);
    padding: 0.84375rem 0 0.84375rem 0;
    background-color: #2d63ab;
    display: flex;
    align-items: center;

    .freightTrackingImg {
      width: 0.875rem;
      height: 0.875rem;
      margin-left: 0.75rem;
      margin-right: 0.5625rem;
    }

    .freightTrackingText {
      font-size: 0.875rem;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
    }
  }

  .freightTrackingCon {
    width: 94%;
    margin: 0 3%;
    // background-color: #004444;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .queryKuang {
      width: 98.5%;
      border: 3px solid;
      border-bottom: none;
      border-image: linear-gradient(270deg, #3676c8, #42be72) 3 3;
      margin-top: 1rem;

      .inputTextarea {
        width: 100%;
        height: 4.0625rem;

        .queryKuangInput {
          width: 100%;
          height: 100%;

          .el-input__inner {
            width: 100%;
            height: 100%;
            border: none;
            text-align: center;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #999999;
          }
        }
      }

      // 立即查询
      .nowQuery {
        width: 100.9%;
        background: linear-gradient(-90deg, #3676c9, #42be72);
        display: flex;
        align-items: center;
        color: #fff;
        justify-content: center;
        font-weight: 900;
        font-family: Source Han Sans CN;

        img {
          width: 0.75rem;
          height: 0.75rem;
          margin-right: 0.375rem;
          margin: 0.875rem 0 0.875rem 0;
        }

        div {
          // width: 100;
          margin-left: 0.375rem;
        }
      }
    }

    .freightTrackingCountry {
      width: 100%;

      .freightTrackingCountryList {
        display: flex;
        align-items: center;
        border-top: 0.0625rem solid rgba(224, 224, 224, 0.7);
        padding-top: 0.75rem;
        padding-bottom: 12px;

        .freightTrackingCountryListCon {
          width: 50%;
          display: flex;
          align-items: center;

          .freightTrackingCountryListConImg {
            width: 2.125rem;
            height: 2.125rem;
            margin-left: 0.4375rem;
            margin-right: 0.71875rem;
          }

          .freightTrackingCountryListConText {
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
          }
        }
      }
    }
  }
}

.bottonBackground {
  width: 96%;
  height: 32.75rem;
  margin: 0 2%;
  margin-top: 13.5px;

  img {
    width: 100%;
    height: 100%;
  }
}

// 小标题
.tableTitleTitle3 {
  // margin: 1.875rem 0 0.625rem 0;
  width: 100%;
  font-size: 0.95rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2e67b1;
  text-align: left;
  margin-bottom: 1.5rem;
  margin-top: 1.80625rem;
}

.buttonImgFT {
  & > img {
    width: 100%;
    height: 7.9375rem;
    z-index: -1;
  }
}
</style>
